import { SchedulerSidebarCrewChangeScope } from '@contexts/scheduler/sidebar/types';
import { CurrentSchedule, RelatedMultischedule } from '@services/schedules/internal/types';
import { formatTime } from '@utils/i18n';
import { formatDate, isBefore, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const checkScheduleDisabled = ({
  schedule,
  currentSchedule,
  crewChangeScope,
  zone,
}: {
  schedule: RelatedMultischedule;
  currentSchedule: CurrentSchedule;
  crewChangeScope: SchedulerSidebarCrewChangeScope;
  zone: string;
}) => {
  const { id, sameForeman, sameCrew, completed } = schedule;
  if (!sameForeman || !sameCrew || completed) return true;
  if (crewChangeScope === 'currentOnly' && currentSchedule.id !== id) return true;
  if (
    crewChangeScope === 'currentAndFuture' &&
    isBefore(
      toZonedTime(parseISO(schedule.startsAt), zone),
      toZonedTime(parseISO(currentSchedule.startsAt), zone),
    )
  )
    return true;
  return false;
};

export const getScheduleDisplayDate = (schedule: RelatedMultischedule, zone: string) => {
  return `${formatDate(toZonedTime(parseISO(schedule.startsAt), zone), 'EEE, dd MMM yyyy')} | ${formatTime(toZonedTime(parseISO(schedule.startsAt), zone))} - ${formatTime(toZonedTime(parseISO(schedule.endsAt), zone))}`;
};
